//作者主页
var author = {

  init: function () {

  }
};